(function(factory){
 'use strict';
 const api=factory();
 if(typeof module==='object'&&module.exports)module.exports=api;
 else api.install(document);
})(function(){
 'use strict';
 function gestureIntent(dx,dy,rtl){
  if(Math.abs(dy)>12&&Math.abs(dy)>=Math.abs(dx)/1.5)return 'scroll';
  if(Math.abs(dx)<52)return 'settle';
  return dx*(rtl?1:-1)>0?'open':'close';
 }
 function install(doc){
  const ar=doc.documentElement.lang.startsWith('ar');
  let active=null,muteClick=null;
  const list=()=>doc.body.dataset.avCatalogView==='list';
  function close(card){
   if(!card)return;
   card.classList.remove('av-swipe-open');
   const drawer=card.querySelector('.av-swipe-reveal');
   if(drawer)drawer.hidden=true;
  }
  function closeAll(except){doc.querySelectorAll('.av-swipe-open').forEach(card=>{if(card!==except)close(card);});}
  function open(card){closeAll(card);card.classList.add('av-swipe-open');card.querySelector('.av-swipe-reveal').hidden=false;}
  function prepare(){
   doc.querySelectorAll('#product-grid .product-card-wrapper:not(.av-swipe-ready)').forEach(card=>{
    const native=card.querySelector('.quick-add__submit');
    const productLink=card.querySelector('.card>.card__content .card__heading a');
    if(!native||!productLink)return;
    card.querySelectorAll('img').forEach(image=>{image.draggable=false;});
    const drawer=doc.createElement('div');drawer.className='av-swipe-reveal';drawer.hidden=true;
    const action=doc.createElement('button');action.type='button';action.dataset.avSwipeAction='add';
    const options=!!native.closest('modal-opener');
    action.textContent=native.disabled?(ar?'نفد المخزون':'Sold out'):(options?(ar?'الخيارات':'Options'):(ar?'أضف للسلة':'Add to cart'));
    action.disabled=native.disabled;
    action.setAttribute('aria-label',action.textContent+' — '+productLink.textContent.trim());
    const icon=native.querySelector('.av-brand-icon');if(icon)action.prepend(icon.cloneNode(true));
    const details=doc.createElement('a');details.href=productLink.href;details.textContent=ar?'التفاصيل':'Details';
    details.setAttribute('aria-label',details.textContent+' — '+productLink.textContent.trim());
    drawer.append(action,details);card.append(drawer);card.classList.add('av-swipe-ready');
   });
  }
  function start(event){
   if(!list()||event.isPrimary===false||event.button>0)return;
   const card=event.target.closest('#product-grid .av-swipe-ready');
   if(!card||event.target.closest('button,input,select,textarea,.quick-add-modal,.av-swipe-reveal'))return;
   active={card,id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,dy:0,rtl:doc.documentElement.dir==='rtl'};
  }
  function move(event){
   if(!active||event.pointerId!==active.id)return;
   active.dx=event.clientX-active.x;active.dy=event.clientY-active.y;
   if(gestureIntent(active.dx,active.dy,active.rtl)==='scroll')active=null;
   else if(Math.abs(active.dx)>12&&event.cancelable)event.preventDefault();
  }
  function finish(event,cancelled){
   if(!active||event.pointerId!==active.id)return;
   active.dx=event.clientX-active.x;active.dy=event.clientY-active.y;
   const state=active;active=null;
   if(cancelled)return;
   const intent=gestureIntent(state.dx,state.dy,state.rtl);
   if(intent==='open'||intent==='close'){
    if(intent==='open')open(state.card);else close(state.card);
    muteClick=state.card;setTimeout(()=>{if(muteClick===state.card)muteClick=null;},400);
   }
  }
  if(typeof doc.defaultView?.PointerEvent==='function'){
   doc.addEventListener('pointerdown',start);
   doc.addEventListener('pointermove',move,{passive:false});
   doc.addEventListener('pointerup',event=>finish(event,false));
   doc.addEventListener('pointercancel',event=>finish(event,true));
  }else{
   const touch=(event,end)=>{const point=(end?event.changedTouches:event.touches)[0];return point&&{target:event.target,pointerId:point.identifier,clientX:point.clientX,clientY:point.clientY,button:0,cancelable:event.cancelable,preventDefault:()=>event.preventDefault()};};
   doc.addEventListener('touchstart',event=>{const p=touch(event,false);if(p)start(p);},{passive:true});
   doc.addEventListener('touchmove',event=>{const p=touch(event,false);if(p)move(p);},{passive:false});
   doc.addEventListener('touchend',event=>{const p=touch(event,true);if(p)finish(p,false);});
   doc.addEventListener('touchcancel',()=>{active=null;});
   doc.addEventListener('mousedown',event=>start(event));
   doc.addEventListener('mousemove',event=>move(event));
   doc.addEventListener('mouseup',event=>finish(event,false));
  }
  doc.addEventListener('dragstart',event=>{if(active)event.preventDefault();});
  doc.addEventListener('click',event=>{
   const reveal=event.target.closest('.av-swipe-reveal');
   if(reveal){
    const trigger=event.target.closest('[data-av-swipe-action="add"]');
    if(trigger){
     event.preventDefault();const card=reveal.closest('.av-swipe-ready');const native=card.querySelector('.quick-add__submit');
     if(!native||native.disabled)return;
     muteClick=null;card.classList.add('av-swipe-no-motion');close(card);
     requestAnimationFrame(()=>{native.click();requestAnimationFrame(()=>card.classList.remove('av-swipe-no-motion'));});
    }
    return;
   }
   const card=event.target.closest('.av-swipe-ready');
   if(card&&muteClick===card){event.preventDefault();event.stopPropagation();muteClick=null;return;}
   if(card?.classList.contains('av-swipe-open')&&!event.target.closest('button')){event.preventDefault();event.stopPropagation();close(card);}
   if(event.target.closest('[data-av-catalog-view]'))closeAll();
  },true);
  doc.addEventListener('keydown',event=>{if(event.key==='Escape')closeAll();});
  doc.addEventListener('shopify:section:load',prepare);
  new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('.product-card-wrapper')||n.querySelector?.('.product-card-wrapper')))))prepare();}).observe(doc.body,{childList:true,subtree:true});
  prepare();
 }
 return {gestureIntent,install};
});
